import { render, staticRenderFns } from "./CustomForm.vue?vue&type=template&id=48f2dead&"
import script from "./CustomForm.vue?vue&type=script&lang=js&"
export * from "./CustomForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports